// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__32q8G","title":"ClientReferral_title__36W9j","itemText":"ClientReferral_itemText__3yjJK"};